/**
 * Nome do logradouro (campo Endereço / deliveryAddress.endereco).
 * Deve aceitar dígitos no nome da via — ex.: "Rua 7 de Setembro", "Av. 15 de Novembro",
 * "Rua das Flores, 123" (quando o vendedor informa tudo no logradouro).
 *
 * Não confundir com deliveryAddressStreetNumber (campo Número / numero).
 */

const MAX_STREET_NAME_LENGTH = 200;

/** Valor de input ou API → string preservando dígitos e pontuação. */
export function coerceDeliveryAddressStreetName(
  value: string | number | null | undefined
): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'number') {
    return Number.isFinite(value) ? String(value) : '';
  }
  return String(value);
}

/** Normalização leve para exibição/edição — nunca remove dígitos. */
export function normalizeDeliveryAddressStreetNameForInput(
  value: string | number | null | undefined
): string {
  return coerceDeliveryAddressStreetName(value);
}

/** Payload à API: trim sem alterar caracteres internos (inclui dígitos). */
export function normalizeDeliveryAddressStreetNameForApi(
  value: string | number | null | undefined
): string {
  return coerceDeliveryAddressStreetName(value).trim();
}

export function isValidDeliveryAddressStreetName(
  value: string | number | null | undefined
): boolean {
  const normalized = normalizeDeliveryAddressStreetNameForApi(value);
  if (!normalized) return false;
  return normalized.length <= MAX_STREET_NAME_LENGTH;
}

export const DELIVERY_ADDRESS_STREET_NAME_EMPTY_ERROR =
  'Informe o endereço (logradouro).';

export const DELIVERY_ADDRESS_STREET_NAME_INVALID_ERROR = `Logradouro inválido (máx. ${MAX_STREET_NAME_LENGTH} caracteres).`;
